module.exports = __webpack_public_path__ + "img/projek2.522bc3d9.png";